import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import {ScreenDetectorService} from '../service/screen-detector.service';
import {debounceTime, distinctUntilChanged, takeUntil} from "rxjs/operators";
import {ScreenDetectorAnswer} from "../@absract/@interface/IConfig.interface";
import {Subject} from "rxjs";

@Directive(
  {
    selector: '[ifScreenMoreThen]'
  }
)
export class IfScreenMoreThenDirective implements OnInit, OnDestroy {

  /**
   * */
  @Input('ifScreenMoreThen') public ifScreenMoreThen: string;

  /**
   * */
  @Input('mzDebounceTime') public mzDebounceTime? = 250;

  /**
   * */
  @Output('mzScreenChange') public mzScreenChange: EventEmitter<ScreenDetectorAnswer> = new EventEmitter<ScreenDetectorAnswer>();

  /**
   * */
  private nInvokedCounter = 0;

  /**
   * */
  private w = 0;

  /**
   * */
  private h = 0;

  /**
   * */
  private alive$: Subject<void> = new Subject();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cdRef: ChangeDetectorRef,
    private screenDetector: ScreenDetectorService
  ) {}

  ngOnInit() {
    this.safeSetParams(this.ifScreenMoreThen);

    this.screenDetector.getSubscription(
      this.mzDebounceTime,
      this.alive$,
      false
    ).subscribe(screen => {
        this.check(screen.width, screen.height);
        this.mzScreenChange.emit(screen);
        this.cdRef.markForCheck();
      }
    );
  }

  ngOnDestroy() {
    this.alive$.next();
    this.alive$.unsubscribe();
  }

  private check(w: number, h: number) {
    this.performCondition((!this.w || this.w < w) && (!this.h || this.h < h));
  }

  /**
   * Ð£ÑÑÐ°Ð½Ð¾Ð²ÐºÐ° Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¾Ð²
   * */
  private safeSetParams(data: string) {
    const params = data.split(',');

    if (params[0]) {
      const w = parseInt(params[0], 10);
      if (!isNaN(w)) this.w = w;
    }

    if (params[1]) {
      const h = parseInt(params[1], 10);
      if (!isNaN(h)) this.h = h;
    }
  }

  /**
   *
   * */
  private performCondition(condition) {
    if (condition) {
      if (this.nInvokedCounter > 0) this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.nInvokedCounter++;
    } else {
      this.viewContainer.clear();
    }
  }
}
